<template>
    <article class="program">
        <h2 class="program__heading">Program</h2>
        <div class="program__room-wrapper">
            <section class="program__room program__room--sala-operowa">
                <div class="program__header">
                    <span class="program__header--head">Sala operowa</span>
                    <span class="program__header--bottom"></span>
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">14:00-14:10</span>
                        <span class="program__lecture--lecture"
                            >Oficjalne otwarcie Breast Fest</span
                        >
                        <span class="program__lecture--lecturer"
                            >Katarzyna Bujakiewicz</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">14:10-14:30</span>
                        <span class="program__lecture--lecture"
                            >Geny i pierwiastki w profilaktyce i leczeniu
                            nowotworów</span
                        >
                        <span class="program__lecture--lecturer"
                            >prof. Jan Lubiński</span
                        >
                        <span class="program__lecture--workplace"
                            >Zakład Genetyki i Patomorfologii,
                        </span>
                        <span class="program__lecture--workplace">
                            Pomorski Uniwersytet Medyczny w Szczecinie
                        </span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">14:30-14:50</span>
                        <span class="program__lecture--lecture"
                            >Spanie na różowo: Jak radzić sobie z problemami ze
                            snem po diagnozie raka piersi?</span
                        >
                        <span class="program__lecture--lecturer"
                            >prof. Helena Rempała</span
                        >
                        <span class="program__lecture--workplace"
                            >Department of Psychiatry and Behavioral Health,
                        </span>
                        <span class="program__lecture--workplace"
                            >The Ohio State University College of Medicine
                        </span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">14:50-15:05</span>
                        <span class="program__lecture--lecture"
                            >Znaczniki tkankowe w chirurgii piersi</span
                        >
                        <span class="program__lecture--lecturer"
                            >dr hab. n. med. Piotr Pluta</span
                        >
                        <span class="program__lecture--workplace"
                            >Instytut Centrum Zdrowia Matki Polki w Łodzi
                        </span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">15:05-15:20</span>
                        <span class="program__lecture--lecture"
                            >ABC diagnostyki i leczenia raka piersi. Jedna opcja
                            to za mało</span
                        >
                        <span class="program__lecture--lecturer"
                            >dr hab. n. med. Andrzej Kurylcio</span
                        >
                        <span class="program__lecture--workplace">
                            Uniwersytet Medyczny w Lublinie
                        </span>
                        <span class="program__lecture--workplace"
                            >Klinika Chirurgii Onkologicznej
                        </span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">15:20-15:35</span>
                        <span class="program__lecture--lecture"
                            >Panel dyskusyjny na temat raka piersi –
                            doświadczenia Pacjentów</span
                        >
                        <span class="program__lecture--lecturer"
                            >Pacjenci o doświadczeniach z rakiem piersi</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">15:35-15:50</span>
                        <span class="program__lecture--lecture"
                            >“Siła kobiet” panel dyskusyjny z Magdą Mołek,
                            Aleksandrą Mirosław i Mają Klajdą Miss Polonia
                            2024</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">15:50-17:00</span>
                        <span class="program__lecture--lecture">Przerwa</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">17:00-17:30</span>
                        <span class="program__lecture--lecture"
                            >Koncert Fisz Emade Soundsystem</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">17:30-17:50</span>
                        <span class="program__lecture--lecture"
                            >Pokaz mody</span
                        >
                        <span class="program__lecture--lecturer"
                            >Pacjentki Kliniki Chirurgii Onkologicznej</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">17:50-18:00</span>
                        <span class="program__lecture--lecture"
                            >Zakończenie</span
                        >
                    </div>
                </div>
            </section>
            <section
                class="program__room program__room--strefa-wystaw-czasowych"
            >
                <div class="program__header">
                    <span class="program__header--head"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                            >Galeria Wystaw Czasowych</a
                        ></span
                    >
                    <span class="program__header--bottom"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                            >Strefa Badań i Konsultacji</a
                        ></span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-14:00</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Konsultacje onkologiczne</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Konsultacje chirurgiczne</a
                            ></span
                        >
                    </div>

                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Konsultacje ginekologiczne</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Badania USG piersi</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Badania genetyczne BRCA</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/badania-i-konsultacje#app"
                                >Badania cytologiczne</a
                            ></span
                        >
                    </div>
                </div>
            </section>
            <section class="program__room program__room--mala-kieszen-sceny">
                <div class="program__header">
                    <span class="program__header--head"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/warsztaty#strefa-warsztatowa"
                            >Mała Kieszeń Sceny</a
                        ></span
                    >
                    <span class="program__header--bottom"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/warsztaty#strefa-warsztatowa"
                            >Strefa Warsztatowa</a
                        ></span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-11:30</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-warsztatowa"
                                >Warsztaty psychoonkologiczne</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">11:30-12:30</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-warsztatowa"
                                >Warsztaty dietetyczne</a
                            ></span
                        >
                    </div>
                </div>
            </section>
            <section class="program__room program__room--duza-kieszen-sceny">
                <div class="program__header">
                    <span class="program__header--head"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                            >Duża Kieszeń Sceny</a
                        ></span
                    >
                    <span class="program__header--bottom"
                        ><a
                            class="program__link"
                            target="_blank"
                            href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                            >Strefa Sportowa</a
                        ></span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-11:00</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                                >Joga z Joy in me</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">11:00-12:00</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                                >Trening funkcjonalny z CityFit</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">12:00-13:00</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                                >Warsztaty fizjoterapeutyczne</a
                            ></span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--hour">13:00-14:00</span>
                        <span class="program__lecture--lecture"
                            ><a
                                class="program__link"
                                target="_blank"
                                href="https://breast-fest.med-space.pl/warsztaty#strefa-sportowa"
                            >
                                Warsztaty pilatesu ze szkołą Klasyczny Pilates
                            </a></span
                        >
                    </div>
                </div>
            </section>
            <section class="program__room program__room--hol-0">
                <div class="program__header">
                    <span class="program__header--head">Hol „0”</span>
                    <span class="program__header--bottom"
                        >Strefa Partnerów</span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-18:00</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Wystawa partnerów</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Badanie Wzroku</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Punkt ,,Podziel się włosem"</span
                        >
                    </div>
                </div>
            </section>
            <section class="program__room program__room--foyer-sali-teatralnej">
                <div class="program__header">
                    <span class="program__header--head"
                        >Foyer Sali Operowej</span
                    >
                    <span class="program__header--bottom"
                        >Strefa Artystyczna</span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-17:00</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Warsztaty plastyczne dla dzieci (Ciche kąty)</span
                        >
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Wystawa portretów pacjentek onkologicznych</span
                        >
                    </div>
                </div>
                <div class="program__header program__header--secondary">
                    <span class="program__header--bottom"
                        >Strefa Mistrzowska</span
                    >
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">13:30-14:00</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Spotkanie motywacyjne z Aleksandrą Mirosław</span
                        >
                    </div>
                </div>
            </section>
            <section class="program__room program__room--plac-teatralny">
                <div class="program__header">
                    <span class="program__header--head">Plac Teatralny</span>
                </div>
                <div class="program__lectures-wrapper">
                    <div class="program__lecture">
                        <span class="program__lecture--hour">10:00-18:00</span>
                    </div>
                    <div class="program__lecture">
                        <span class="program__lecture--lecture"
                            >Badania mammograficzne – Mammobus</span
                        >
                    </div>
                </div>
            </section>
        </div>
        <div class="program__footer">
            <p class="program__footer-text">
                <sup>*</sup>Organizator zastrzega sobie prawo do wprowadzania
                zmian w programie.
            </p>
            <p class="program__footer-text">
                <sup id="footer-text">**</sup>Szczegółowe godziny poszczególnych
                konsultacji oraz warsztatów zostaną podane wkrótce. Wymagana
                będzie rejestracja.
            </p>
        </div>
    </article>
</template>
<script>
export default {
    data() {
        return {
            title: "program",
        };
    },
};
</script>
